import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/contact.css";

const Contact = () => {

  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });

  const [status, setStatus] = useState("idle");
  const [countdown, setCountdown] = useState(3);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      await fetch("https://script.google.com/macros/s/AKfycbx44iseSe8GNJfR78KOf8yNMrYva13RYExqRUxkd2GOYSjzMATqVB-FtzhEPpXRBNnB/exec", {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form)
      });

      setStatus("success");
      setForm({
        name: "",
        email: "",
        phone: "",
        message: ""
      });

      // Countdown redirect
      let timer = 3;
      const interval = setInterval(() => {
        timer--;
        setCountdown(timer);
        if (timer === 0) {
          clearInterval(interval);
          navigate("/courses");
        }
      }, 1000);

    } catch (err) {
      setStatus("error");
      console.log(err);
    }
  };

  return (
    <div className="contact-page">

      <section className="contact-hero">
        <div className="container">
          <h1>Contact US</h1>
          <p>Get in touch for admission & course details</p>
        </div>
      </section>

      <section className="contact-container container">

        {/* LEFT SIDE - MAP + INFO */}
        <div className="contact-left">

          <div className="map-box">
            <iframe
              title="ICA Global Location"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d938961.9466325169!2d75.790661!3d23.176765!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396375c527bccb8f%3A0xb04755f585c7385d!2stally%20academy%20in%20ujjain%20%26%20ICA%20Institute%20of%20Computer%20and%20Accounting!5e0!3m2!1sen!2sin!4v1771647998894!5m2!1sen!2sin"
              width="100%"
              height="250"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>

          <div className="contact-info-card">
            <h3>Institute Address</h3>
            <p>ICA Global Institute, Ujjain</p>
            <p>📞 +91 8819873122</p>
            <p>✉ info@icaglobal.in</p>
          </div>

        </div>

        {/* RIGHT SIDE - FORM */}
        <form className="contact-form" onSubmit={handleSubmit} noValidate>
          <input name="name" value={form.name} onChange={handleChange} placeholder="Your Name" required />
          <input name="email" value={form.email} onChange={handleChange} placeholder="Email" required />
          <input name="phone" value={form.phone} onChange={handleChange} placeholder="Phone" required />
          <textarea name="message" value={form.message} onChange={handleChange} placeholder="Message"></textarea>

          <button type="submit" disabled={status === "loading"}>
            {status === "loading" ? "Sending..." : "Send Message"}
          </button>

          {status === "success" && (
            <div className="form-success">
              🎉 Enquiry Submitted Successfully! Redirecting in {countdown} seconds...
            </div>
          )}

          {status === "error" && (
            <div className="form-error">
              ❌ Something went wrong. Please try again.
            </div>
          )}
        </form>
      </section>
    </div>
  );
};

export default Contact; 